import React from 'react'
import { Platform } from 'react-native'
import { Circle, G } from 'react-native-svg'
import { territoryMarkerMetrics, territoryMarkerArmedRing, opaqueMarkerFill } from './geometry'

/** Ownership disc shared by the live board and map previews. Counts use TroopBadge. */
export const TerritoryMarker = React.memo(function TerritoryMarker({
  id, x, y, radius, fill, landscape = false, desktop = false, label, onPress, dimmed = false, armed = false, pointer = false,
}: {
  id: string; x: number; y: number; radius: number; fill: string
  landscape?: boolean; desktop?: boolean; label?: string; onPress?: (id: string) => void; dimmed?: boolean; armed?: boolean
  /** Web-only: hand cursor on hover, matching the actionable territory beneath. */
  pointer?: boolean
}) {
  const metrics = territoryMarkerMetrics(radius, landscape, desktop)
  const armedRing = territoryMarkerArmedRing(metrics.radius)
  // The cursor lives on the group, like the territory shapes and decorations:
  // Circle has no style prop. The armed ring ignores the pointer, and the troop
  // number above (TroopBadge) is pointerEvents="none", so the hand shows over
  // the whole disc, number included.
  return <G style={pointer && Platform.OS === 'web' ? ({ cursor: 'pointer' } as never) : undefined}>
    <Circle testID={`territory-marker-${id}`} cx={x} cy={y} r={metrics.radius} fill={opaqueMarkerFill(fill, dimmed)}
    stroke="#171717" strokeWidth={metrics.strokeWidth}
    accessibilityLabel={label} onPress={onPress ? () => onPress(id) : undefined}
    pointerEvents={onPress ? 'auto' : 'none'} />
    {armed && !dimmed && <Circle testID={`marker-armed-${id}`} cx={x} cy={y}
      r={armedRing.radius} fill="none" stroke="#ffffff" strokeWidth={armedRing.strokeWidth}
      pointerEvents="none" />}
  </G>
})
